import { compose, withHandlers } from 'recompose';
import AmountModal from '../components/AmountModal';

const AmountModalContainer = compose(
  withHandlers({
    onCustomSubmit: props => amount => props.onSubmit(amount),
  }),
);

export default AmountModalContainer(AmountModal);
